module.exports = __webpack_public_path__ + "static/impulso-bayer-6-752ba6ad02414ac81cdc6a1bafb9b518.jpg";